module.exports = __webpack_public_path__ + "img/top.d54309ce.png";